import { serviceApi } from '~/features/QueryClient';

export async function recoveryPassword(email: string): Promise<void> {
  await serviceApi.post('/Usuario/RecuperacaoSenha', { email });
}
